// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon {
    font-size: 18px;
    margin: 8px;
    cursor: pointer;
}

.print_icon {
    font-size: 18px;
    margin: 8px;
    /* cursor: pointer; */
}

.hand {
    cursor: pointer;
}

.pagination_count_row{
    border: 1px solid;
    width: 25%;
    border-radius: 5px;
    margin-bottom: 15px !important;

}
.pagination_count_tab{
    width: 25%;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    border-right: 1px solid;
    /* border-top-right-radius:5px; */
    /* border-bottom-right-radius: 5px; */
}

.selected_tab{
    background-color: var(--admin-color);
    color: white;
    font-weight: 600;
}

table.dataTable {
    clear: both;
    margin-top: 6px !important;
    margin-bottom: 6px !important;
    max-width: none !important;
    border-collapse: separate !important;
    border-spacing: 0
}

table.dataTable td,
table.dataTable th {
    box-sizing: content-box
}

table.dataTable td.dataTables_empty,
table.dataTable th.dataTables_empty {
    text-align: center
}

table.dataTable.nowrap th,
table.dataTable.nowrap td {
    white-space: nowrap
}

div.dataTables_wrapper div.dataTables_length label {
    font-weight: normal;
    text-align: left;
    white-space: nowrap
}

div.dataTables_wrapper div.dataTables_length select {
    width: auto;
    display: inline-block
}

div.dataTables_wrapper div.dataTables_filter {
    text-align: right
}

div.dataTables_wrapper div.dataTables_filter label {
    font-weight: normal;
    white-space: nowrap;
    text-align: left
}

div.dataTables_wrapper div.dataTables_filter input {
    margin-left: 0.5em;
    display: inline-block;
    width: auto
}

div.dataTables_wrapper div.dataTables_info {
    padding-top: 0.85em;
    white-space: nowrap
}

div.dataTables_wrapper div.dataTables_paginate {
    margin: 0;
    white-space: nowrap;
    text-align: right
}

div.dataTables_wrapper div.dataTables_paginate ul.pagination {
    margin: 2px 0;
    white-space: nowrap;
    justify-content: flex-end
}

div.dataTables_wrapper div.dataTables_processing {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 200px;
    margin-left: -100px;
    margin-top: -26px;
    text-align: center;
    padding: 1em 0
}

table.dataTable thead>tr>th.sorting_asc,
table.dataTable thead>tr>th.sorting_desc,
table.dataTable thead>tr>th.sorting,
table.dataTable thead>tr>td.sorting_asc,
table.dataTable thead>tr>td.sorting_desc,
table.dataTable thead>tr>td.sorting {
    padding-right: 30px
}

table.dataTable thead>tr>th:active,
table.dataTable thead>tr>td:active {
    outline: none
}

table.dataTable thead .sorting,
table.dataTable thead .sorting_asc,
table.dataTable thead .sorting_desc,
table.dataTable thead .sorting_asc_disabled,
table.dataTable thead .sorting_desc_disabled {
    cursor: pointer;
    position: relative
}

table.dataTable thead .sorting:before,
table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:before,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:before,
table.dataTable thead .sorting_desc:after,
table.dataTable thead .sorting_asc_disabled:before,
table.dataTable thead .sorting_asc_disabled:after,
table.dataTable thead .sorting_desc_disabled:before,
table.dataTable thead .sorting_desc_disabled:after {
    position: absolute;
    bottom: 0.9em;
    display: block;
    opacity: 0.3
}

table.dataTable thead .sorting:before,
table.dataTable thead .sorting_asc:before,
table.dataTable thead .sorting_desc:before,
table.dataTable thead .sorting_asc_disabled:before,
table.dataTable thead .sorting_desc_disabled:before {
    right: 1em;
    content: "\\2191"
}

table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after,
table.dataTable thead .sorting_asc_disabled:after,
table.dataTable thead .sorting_desc_disabled:after {
    right: 0.5em;
    content: "\\2193"
}

table.dataTable thead .sorting_asc:before,
table.dataTable thead .sorting_desc:after {
    opacity: 1
}

table.dataTable thead .sorting_asc_disabled:before,
table.dataTable thead .sorting_desc_disabled:after {
    opacity: 0
}

div.dataTables_scrollHead table.dataTable {
    margin-bottom: 0 !important
}

div.dataTables_scrollBody table {
    border-top: none;
    margin-top: 0 !important;
    margin-bottom: 0 !important
}

div.dataTables_scrollBody table thead .sorting:before,
div.dataTables_scrollBody table thead .sorting_asc:before,
div.dataTables_scrollBody table thead .sorting_desc:before,
div.dataTables_scrollBody table thead .sorting:after,
div.dataTables_scrollBody table thead .sorting_asc:after,
div.dataTables_scrollBody table thead .sorting_desc:after {
    display: none
}

div.dataTables_scrollBody table tbody tr:first-child th,
div.dataTables_scrollBody table tbody tr:first-child td {
    border-top: none
}

div.dataTables_scrollFoot>.dataTables_scrollFootInner {
    box-sizing: content-box
}

div.dataTables_scrollFoot>.dataTables_scrollFootInner>table {
    margin-top: 0 !important;
    border-top: none
}

@media screen and (max-width: 767px) {

    div.dataTables_wrapper div.dataTables_length,
    div.dataTables_wrapper div.dataTables_filter,
    div.dataTables_wrapper div.dataTables_info,
    div.dataTables_wrapper div.dataTables_paginate {
        text-align: center
    }
}

table.dataTable.table-sm>thead>tr>th {
    padding-right: 20px
}

table.dataTable.table-sm .sorting:before,
table.dataTable.table-sm .sorting_asc:before,
table.dataTable.table-sm .sorting_desc:before {
    top: 5px;
    right: 0.85em
}

table.dataTable.table-sm .sorting:after,
table.dataTable.table-sm .sorting_asc:after,
table.dataTable.table-sm .sorting_desc:after {
    top: 5px
}

table.table-bordered.dataTable th,
table.table-bordered.dataTable td {
    border-left-width: 0
}

table.table-bordered.dataTable th:last-child,
table.table-bordered.dataTable th:last-child,
table.table-bordered.dataTable td:last-child,
table.table-bordered.dataTable td:last-child {
    border-right-width: 0
}

table.table-bordered.dataTable tbody th,
table.table-bordered.dataTable tbody td {
    border-bottom-width: 0
}

div.dataTables_scrollHead table.table-bordered {
    border-bottom-width: 0
}

div.table-responsive>div.dataTables_wrapper>div.row {
    margin: 0
}

div.table-responsive>div.dataTables_wrapper>div.row>div[className^="col-"]:first-child {
    padding-left: 0
}

div.table-responsive>div.dataTables_wrapper>div.row>div[className^="col-"]:last-child {
    padding-right: 0
}

.loderShow{
    display: block;
}
.loderHide{
    display: none;
}

.recipientHasSelected {
    background-color: #f9fafb !important;
}`, "",{"version":3,"sources":["webpack://./src/Components/Customer/CustomerTable/CustomerTable.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV,kBAAkB;IAClB,8BAA8B;;AAElC;AACA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,uBAAuB;IACvB,iCAAiC;IACjC,qCAAqC;AACzC;;AAEA;IACI,oCAAoC;IACpC,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,0BAA0B;IAC1B,6BAA6B;IAC7B,0BAA0B;IAC1B,oCAAoC;IACpC;AACJ;;AAEA;;IAGI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB;AACJ;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,SAAS;IACT,mBAAmB;IACnB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB;AACJ;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;;;;;;IAMI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;IAKI,eAAe;IACf;AACJ;;AAEA;;;;;;;;;;IAUI,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd;AACJ;;AAEA;;;;;IAKI,UAAU;IACV;AACJ;;AAEA;;;;;IAKI,YAAY;IACZ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;IACxB;AACJ;;AAEA;;;;;;IAMI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,wBAAwB;IACxB;AACJ;;AAEA;;IAEI;;;;QAII;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;;;IAGI,QAAQ;IACR;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;AAClB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,oCAAoC;AACxC","sourcesContent":[".icon {\n    font-size: 18px;\n    margin: 8px;\n    cursor: pointer;\n}\n\n.print_icon {\n    font-size: 18px;\n    margin: 8px;\n    /* cursor: pointer; */\n}\n\n.hand {\n    cursor: pointer;\n}\n\n.pagination_count_row{\n    border: 1px solid;\n    width: 25%;\n    border-radius: 5px;\n    margin-bottom: 15px !important;\n\n}\n.pagination_count_tab{\n    width: 25%;\n    height: 30px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    border-right: 1px solid;\n    /* border-top-right-radius:5px; */\n    /* border-bottom-right-radius: 5px; */\n}\n\n.selected_tab{\n    background-color: var(--admin-color);\n    color: white;\n    font-weight: 600;\n}\n\ntable.dataTable {\n    clear: both;\n    margin-top: 6px !important;\n    margin-bottom: 6px !important;\n    max-width: none !important;\n    border-collapse: separate !important;\n    border-spacing: 0\n}\n\ntable.dataTable td,\ntable.dataTable th {\n    -webkit-box-sizing: content-box;\n    box-sizing: content-box\n}\n\ntable.dataTable td.dataTables_empty,\ntable.dataTable th.dataTables_empty {\n    text-align: center\n}\n\ntable.dataTable.nowrap th,\ntable.dataTable.nowrap td {\n    white-space: nowrap\n}\n\ndiv.dataTables_wrapper div.dataTables_length label {\n    font-weight: normal;\n    text-align: left;\n    white-space: nowrap\n}\n\ndiv.dataTables_wrapper div.dataTables_length select {\n    width: auto;\n    display: inline-block\n}\n\ndiv.dataTables_wrapper div.dataTables_filter {\n    text-align: right\n}\n\ndiv.dataTables_wrapper div.dataTables_filter label {\n    font-weight: normal;\n    white-space: nowrap;\n    text-align: left\n}\n\ndiv.dataTables_wrapper div.dataTables_filter input {\n    margin-left: 0.5em;\n    display: inline-block;\n    width: auto\n}\n\ndiv.dataTables_wrapper div.dataTables_info {\n    padding-top: 0.85em;\n    white-space: nowrap\n}\n\ndiv.dataTables_wrapper div.dataTables_paginate {\n    margin: 0;\n    white-space: nowrap;\n    text-align: right\n}\n\ndiv.dataTables_wrapper div.dataTables_paginate ul.pagination {\n    margin: 2px 0;\n    white-space: nowrap;\n    justify-content: flex-end\n}\n\ndiv.dataTables_wrapper div.dataTables_processing {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 200px;\n    margin-left: -100px;\n    margin-top: -26px;\n    text-align: center;\n    padding: 1em 0\n}\n\ntable.dataTable thead>tr>th.sorting_asc,\ntable.dataTable thead>tr>th.sorting_desc,\ntable.dataTable thead>tr>th.sorting,\ntable.dataTable thead>tr>td.sorting_asc,\ntable.dataTable thead>tr>td.sorting_desc,\ntable.dataTable thead>tr>td.sorting {\n    padding-right: 30px\n}\n\ntable.dataTable thead>tr>th:active,\ntable.dataTable thead>tr>td:active {\n    outline: none\n}\n\ntable.dataTable thead .sorting,\ntable.dataTable thead .sorting_asc,\ntable.dataTable thead .sorting_desc,\ntable.dataTable thead .sorting_asc_disabled,\ntable.dataTable thead .sorting_desc_disabled {\n    cursor: pointer;\n    position: relative\n}\n\ntable.dataTable thead .sorting:before,\ntable.dataTable thead .sorting:after,\ntable.dataTable thead .sorting_asc:before,\ntable.dataTable thead .sorting_asc:after,\ntable.dataTable thead .sorting_desc:before,\ntable.dataTable thead .sorting_desc:after,\ntable.dataTable thead .sorting_asc_disabled:before,\ntable.dataTable thead .sorting_asc_disabled:after,\ntable.dataTable thead .sorting_desc_disabled:before,\ntable.dataTable thead .sorting_desc_disabled:after {\n    position: absolute;\n    bottom: 0.9em;\n    display: block;\n    opacity: 0.3\n}\n\ntable.dataTable thead .sorting:before,\ntable.dataTable thead .sorting_asc:before,\ntable.dataTable thead .sorting_desc:before,\ntable.dataTable thead .sorting_asc_disabled:before,\ntable.dataTable thead .sorting_desc_disabled:before {\n    right: 1em;\n    content: \"\\2191\"\n}\n\ntable.dataTable thead .sorting:after,\ntable.dataTable thead .sorting_asc:after,\ntable.dataTable thead .sorting_desc:after,\ntable.dataTable thead .sorting_asc_disabled:after,\ntable.dataTable thead .sorting_desc_disabled:after {\n    right: 0.5em;\n    content: \"\\2193\"\n}\n\ntable.dataTable thead .sorting_asc:before,\ntable.dataTable thead .sorting_desc:after {\n    opacity: 1\n}\n\ntable.dataTable thead .sorting_asc_disabled:before,\ntable.dataTable thead .sorting_desc_disabled:after {\n    opacity: 0\n}\n\ndiv.dataTables_scrollHead table.dataTable {\n    margin-bottom: 0 !important\n}\n\ndiv.dataTables_scrollBody table {\n    border-top: none;\n    margin-top: 0 !important;\n    margin-bottom: 0 !important\n}\n\ndiv.dataTables_scrollBody table thead .sorting:before,\ndiv.dataTables_scrollBody table thead .sorting_asc:before,\ndiv.dataTables_scrollBody table thead .sorting_desc:before,\ndiv.dataTables_scrollBody table thead .sorting:after,\ndiv.dataTables_scrollBody table thead .sorting_asc:after,\ndiv.dataTables_scrollBody table thead .sorting_desc:after {\n    display: none\n}\n\ndiv.dataTables_scrollBody table tbody tr:first-child th,\ndiv.dataTables_scrollBody table tbody tr:first-child td {\n    border-top: none\n}\n\ndiv.dataTables_scrollFoot>.dataTables_scrollFootInner {\n    box-sizing: content-box\n}\n\ndiv.dataTables_scrollFoot>.dataTables_scrollFootInner>table {\n    margin-top: 0 !important;\n    border-top: none\n}\n\n@media screen and (max-width: 767px) {\n\n    div.dataTables_wrapper div.dataTables_length,\n    div.dataTables_wrapper div.dataTables_filter,\n    div.dataTables_wrapper div.dataTables_info,\n    div.dataTables_wrapper div.dataTables_paginate {\n        text-align: center\n    }\n}\n\ntable.dataTable.table-sm>thead>tr>th {\n    padding-right: 20px\n}\n\ntable.dataTable.table-sm .sorting:before,\ntable.dataTable.table-sm .sorting_asc:before,\ntable.dataTable.table-sm .sorting_desc:before {\n    top: 5px;\n    right: 0.85em\n}\n\ntable.dataTable.table-sm .sorting:after,\ntable.dataTable.table-sm .sorting_asc:after,\ntable.dataTable.table-sm .sorting_desc:after {\n    top: 5px\n}\n\ntable.table-bordered.dataTable th,\ntable.table-bordered.dataTable td {\n    border-left-width: 0\n}\n\ntable.table-bordered.dataTable th:last-child,\ntable.table-bordered.dataTable th:last-child,\ntable.table-bordered.dataTable td:last-child,\ntable.table-bordered.dataTable td:last-child {\n    border-right-width: 0\n}\n\ntable.table-bordered.dataTable tbody th,\ntable.table-bordered.dataTable tbody td {\n    border-bottom-width: 0\n}\n\ndiv.dataTables_scrollHead table.table-bordered {\n    border-bottom-width: 0\n}\n\ndiv.table-responsive>div.dataTables_wrapper>div.row {\n    margin: 0\n}\n\ndiv.table-responsive>div.dataTables_wrapper>div.row>div[className^=\"col-\"]:first-child {\n    padding-left: 0\n}\n\ndiv.table-responsive>div.dataTables_wrapper>div.row>div[className^=\"col-\"]:last-child {\n    padding-right: 0\n}\n\n.loderShow{\n    display: block;\n}\n.loderHide{\n    display: none;\n}\n\n.recipientHasSelected {\n    background-color: #f9fafb !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
